<template>
  <div class="rank">
    <!-- <div class="dsph">
      <div>大赛排行</div>
    </div> -->
    <div class="dsph-con">
      <div>
        <div class="title dsphtext"></div>
        <div>
          <div class="searchcontent"><label>产品名称</label><input v-model="productName"/><label>机构名称</label><input v-model="institutName"/>
            <div class="searchbutton" @click="searchInfo">搜索</div>
          </div>
          <div class="page">
            <pagination :currentPage="currentPage" :pageCount="pageCount" @goPrePage="goPrePage"
                        @goNextPage="goNextPage"></pagination></div>
          <div class="tables">
            <ul class="fivelevel">
              <li :class="[{'active':groupService=='1'}]">
                <div @click="changeActiveTitle('1','gp')"><span v-if="groupService!='1'">股票策略</span><img v-if="groupService=='1'" src="../assets/gpcl.png" /><span class="groupNum">（{{allData.gpCounts}}）</span></div>
              </li><li :class="[{'active':groupService=='2'}]">
              <div @click="changeActiveTitle('2','dc')"><span v-if="groupService!='2'">对冲策略</span><img v-if="groupService=='2'" src="../assets/dccl.png" /><span class="groupNum">（{{allData.dcCounts}}）</span></div>
              </li><li :class="[{'active':groupService=='3'}]">
              <div @click="changeActiveTitle('3','cta')"><span v-if="groupService!='3'">CTA及衍生品策略</span><img style="width: 150px;" v-if="groupService=='3'" src="../assets/CTArank.png" /><span class="groupNum">（{{allData.ctaCounts}}）</span></div>
              </li><li :class="[{'active':groupService=='4'}]">
              <div @click="changeActiveTitle('4','hh')"><span v-if="groupService!='4'">混合策略</span><img v-if="groupService=='4'" src="../assets/hhcl.png" /><span class="groupNum">（{{allData.hhCounts}}）</span></div>
              </li><li :class="[{'active':groupService=='5'}]">
              <div @click="changeActiveTitle('5','qt')"><span v-if="groupService!='5'">其他策略</span><img v-if="groupService=='5'" src="../assets/qtcl.png" /><span class="groupNum">（{{allData.qtCounts}}）</span></div>
              </li>
            </ul>
            <ul class="table tableth">
              <li>排名</li><li>基金名称
            </li><li @click="changesort(0)">综合评分
              <img v-if="orderValue!=0" src="../assets/common.png" />
              <img v-if="orderValue==0&&orderType==1" src="../assets/up.png" />
              <img v-if="orderValue==0&&orderType==0" src="../assets/down.png" />
            </li><li @click="changesort(1)">累计收益率
              <img v-if="orderValue!=1" src="../assets/common.png" />
              <img v-if="orderValue==1&&orderType==1" src="../assets/up.png" />
              <img v-if="orderValue==1&&orderType==0" src="../assets/down.png" />
            </li><li @click="changesort(3)">最大回撤
              <img v-if="orderValue!=3" src="../assets/common.png" />
              <img v-if="orderValue==3&&orderType==1" src="../assets/up.png" />
              <img v-if="orderValue==3&&orderType==0" src="../assets/down.png" />
            </li><li>公司名称</li>
            </ul>
            <ul class="table tabletd" v-for="(item,index) in rankList" :key="index" @click="goDetail(item.id,item.rankNum)">
              <li v-if="item.rankNum==1"><img class="num" src="../assets/1.png" /></li>
              <li v-else-if="item.rankNum==2"><img class="num" src="../assets/2.png" /></li>
              <li v-else-if="item.rankNum==3"><img class="num" src="../assets/3.png" /></li>
              <li v-else>{{item.rankNum}}</li><li><span class="cxh"><img v-if="item.isProcedural==1" src="../assets/cxh-icon.png" /><a class="cxhjy">程序化交易</a></span><div class="name">{{item.productName}}</div></li><li>{{item.zhpf}}</li><li :class="[{'green':item.nhsyl<0},{'red':item.nhsyl>0}]"><span>{{(item.nhsyl !== '--')||(item.nhsyl == '') ? Math.round(item.nhsyl * 100*100)/100 + '%' : item.nhsyl}}</span><img class="colorarrow" v-if="item.nhsyl<0" src="../assets/greendown.png" /><img class="colorarrow" v-if="item.nhsyl>0" src="../assets/redup.png" /></li><!--<li>{{item.sharp}}</li>--><li>{{(item.maxhcl !== '--')||item.maxhcl == '' ? Math.round(item.maxhcl * 100*100)/100 + '%' : item.maxhcl}}</li><li><div class="name">{{item.institutName}}</div></li>
            </ul>
          </div>
          <div class="page">
            <pagination :currentPage="currentPage" :pageCount="pageCount" @goPrePage="goPrePageAndTop"
                        @goNextPage="goNextPageAndTop"></pagination></div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
  import {http} from '../fetch/api'
  import format from '../fetch/format'
  import pagination from './common/pagination'

  export default {
    components: {
      pagination
    },
    data() {
      return {
        groupService: "1",
        productName:"",
        institutName:"",
        orderType:0,
        orderValue: 0,
        temp: 0,
        rankList: [],
        pageSize: 20,

        currentPage: 1,
        pageCount: 0,//页数
        allData:[],
        groupName:'gp',
        activePage:'',
        activeIndex:0
      }
    },
    mounted() {
      if(this.$store.state.loginState) {
        this.getList(this.productName,this.institutName,this.groupService,this.orderValue,this.orderType,this.currentPage, this.pageSize)
      } else {
        var temp=format.formatKeys(this.$route.query)
        var params=temp.substring(0,temp.length-1)
        this.$router.push("/?"+params)
        // this.$set(this.$store.state,'loginState',false)
        // this.$forceUpdate()
      }
    },
    methods: {
      searchInfo() {
        this.currentPage = 1
        if(this.productName=="" && this.institutName=="") {
          this.getList(this.productName,this.institutName,this.groupService,this.orderValue,this.orderType,this.currentPage, this.pageSize)
        } else {
          this.searchBtn(this.productName,this.institutName,this.groupService,this.orderValue,this.orderType,this.currentPage, this.pageSize)
        }
      },
      changesort(orderValue) {
        if(this.temp==orderValue) {
          this.orderType==0?this.orderType=1:this.orderType=0
        } else {
          this.temp=orderValue
          this.orderType=0
        }
        this.orderValue=orderValue
        this.getList(this.productName,this.institutName,this.groupService,this.orderValue,this.orderType,this.currentPage, this.pageSize)
      },
      changeActiveTitle(activeTitle,activeName) {
        this.currentPage = 1
        this.groupService=activeTitle
        this.groupName = activeName
        this.rankList = this.allData[activeName]
        this.pageCount = this.allData[activeName + 'Total']
        if(activeName == this.activePage){
          this.currentPage = this.activeIndex
        }
      },
      goNextPage(index) {
        this.currentPage=index?index:this.currentPage+1
        this.keepCurPage()
        this.getList(this.productName,this.institutName,this.groupService,this.orderValue,this.orderType,this.currentPage, this.pageSize)
      },
      goPrePage(index) {
        this.currentPage=index?index:this.currentPage-1
        this.keepCurPage()
        this.getList(this.productName,this.institutName,this.groupService,this.orderValue,this.orderType,this.currentPage, this.pageSize)
      },
      goDetail(id,rankNum) {
        var temp=format.formatKeys(this.$route.query)
        var params=temp+"productId="+id+"&rankNum="+rankNum
        let routeUrl = this.$router.resolve({
          path: "/rankdetail?" + params
        });
        window.open(routeUrl.href);
      },
      async getList(productName,institutName,groupService,orderValue,orderType,index, size) {
        var data = await http.season(productName,institutName,groupService,orderValue,orderType,index, size)
        this.allData = data.data
        this.currentPage = data.pageIndex
        this.pageCount = data.data[this.groupName + 'Total']
        this.rankList = data.data[this.groupName]
      },
      async searchBtn(productName,institutName,groupService,orderValue,orderType,index, size) {
        var data = await http.season(productName,institutName,groupService,orderValue,orderType,index, size)
        this.allData = data.data
        this.currentPage = data.pageIndex
        this.pageCount = data.data[this.groupName + 'Total']
        this.rankList = data.data[this.groupName]
      },
      goPrePageAndTop(index){
        document.body.scrollTop = 490;
        document.documentElement.scrollTop = 490;
        this.currentPage=index?index:this.currentPage-1
        this.keepCurPage()
        this.getList(this.productName,this.institutName,this.groupService,this.orderValue,this.orderType,this.currentPage, this.pageSize)
      },
      goNextPageAndTop(index){
        document.body.scrollTop = 490;
        document.documentElement.scrollTop = 490;
        this.currentPage=index?index:this.currentPage+1
        this.keepCurPage()
        this.getList(this.productName,this.institutName,this.groupService,this.orderValue,this.orderType,this.currentPage, this.pageSize)
      },
      keepCurPage(){
        if(this.currentPage !==1 ){
          this.activePage = this.groupName
          this.activeIndex = this.currentPage
        }
      }
    }
  }
</script>
<style scoped>

  .dsph {
    height: 60px;
    line-height: 60px;
  }

  .dsph div {
    width: 1200px;
    margin: 0 auto;
    font-size: 16px;
  }

  .dsph-con > div {
    padding: 50px 0;
    width: 1200px;
    margin: 0 auto;
  }

  .title {
    height: 67px;
    line-height: 67px;
    text-align: center;
    font-size: 30px;
    letter-spacing: 5px;
    margin: 0 auto 35px auto;
    background-repeat: no-repeat;
    background-size: 750px;
    background-position: center;
  }

  .title span {
    padding-left: 50px;
    display: inline-block;
    background-image: -webkit-linear-gradient(73deg, #0c3b95, #cf5860);
    background-image: -o-linear-gradient(73deg, #0c3b95, #cf5860);
    background-image: -moz-linear-gradient(73deg, #0c3b95, #cf5860);
    background-image: linear-gradient(73deg, #0c3b95, #cf5860);
    -webkit-background-clip: text;
    -ms-background-clip: text;
    -o-background-clip: text;
    -moz-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    -o-text-fill-color: transparent;
    -moz-text-fill-color: transparent;
    text-fill-color: transparent;
    font-weight: bold;
  }

  .dsphtext {
    background-image: url("../assets/dsph.png");
  }

  .searchcontent {
    width: 1200px;
    margin: 0 auto;
    text-align: center;
  }

  .searchcontent label {
    color: #27a7ea;
  }

  .searchcontent input {
    margin-left: 5px;
    margin-right: 30px;
    height: 40px;
    line-height: 40px;
    padding-left: 10px;
    width: 300px;
    border-radius: 6px;
    outline: none;
    border: solid 1px #5d5d5d;
  }

  .searchcontent div {
    display: inline-block;
    width: 80px;
    height: 40px;
    line-height: 40px;
    color: #fff;
    background: #27a7ea;
    border-radius: 6px;
  }

  ul.fivelevel {
    width: 1200px;
    color: #27a7ea;
    font-weight: 600;
    height: 52px;
    line-height: 52px;
    background: url("../assets/phbt1.png") no-repeat;
    background-size: contain;
  }

  .fivelevel li {
    list-style: none;
    display: inline-block;
    width: 20%;
    text-align: center;
    color: #27a7ea;
  }
  .fivelevel li .groupNum{
    color: #8282FF;
  }

  .fivelevel li.active {
    display: inline-block;
    background: url("../assets/active.png") no-repeat center top;
  }
.fivelevel img {
  vertical-align: middle;
  width: 75px;
}
  .table {
    width: 1200px;
    height: 50px;
    line-height: 50px;
  }

  .table li {
    text-align: center;
    display: inline-block;
    width: calc(16.666%);
    /*width:171px;*/
  }
  .table li .name {
    vertical-align: top;
    display: inline-block;
    overflow: hidden;
    max-width: calc(100% - 25px);
    /*max-width:174px;*/
    /*overflow: hidden;*/
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .tableth {
    color: #2ba3ef;
    background-image: url("../assets/phbt2.png");
    background-size: contain;
  }

  .tabletd {
    border-bottom: 1px transparent solid;
    border-image: -webkit-linear-gradient(90deg, #fff, #ddddde, #fff) 10 10;
    border-image: -o-linear-gradient(90deg, #fff, #ddddde, #fff) 10 10;
    border-image: -moz-linear-gradient(90deg, #fff, #ddddde, #fff) 10 10;
    border-image: linear-gradient(90deg, #fff, #ddddde, #fff) 10 10;
  }

  .tabletd:hover {
    background-image: -webkit-linear-gradient(90deg, #fff, #e6f8ff, #fff);
    background-image: -o-linear-gradient(90deg, #fff, #e6f8ff, #fff);
    background-image: -moz-linear-gradient(90deg, #fff, #e6f8ff, #fff);
    background-image: linear-gradient(90deg, #fff, #e6f8ff, #fff);

  }
  .tableth img {
    width: 10px;
    vertical-align: middle;
    margin-left: 5px;
    margin-top: -5px;
  }
  .rank {
    padding-bottom: 50px;
  }
  .page {
    margin: 25px 0 10px 0;
  }
  .num {
    width: 50px;
    vertical-align: middle;
  }
  .cxh {
    position: relative;
    display: inline-block;
    margin-right: 10px;
    vertical-align: middle;
  }
  .cxh img {
    width: 15px;
  }
  .cxh .cxhjy {
    position: absolute;
    display: none;
    top: 32px;
    left: -40px;
    color: #767676;
    font-size: 14px;
    width:80px;
    padding: 0 5px;
    border-radius: 3px;
    background: #fff;
    height: 20px;
    line-height: 20px;
  }
  .cxh:hover .cxhjy {
    display: inline-block;
  }
  .green {
    color: #2cbd36;
  }
  .red {
    color: #e63636;
  }
  .colorarrow {
    width: 15px;
    vertical-align: middle;
    margin-top: -4px;
  }
</style>



// WEBPACK FOOTER //
// src/components/rank.vue